import { render, staticRenderFns } from "./TeamsIndex.vue?vue&type=template&id=5e6e543b&scoped=true&"
import script from "./TeamsIndex.vue?vue&type=script&lang=js&"
export * from "./TeamsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e543b",
  null
  
)

export default component.exports